var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "terms-icon",
    d: "M12 1L20.217 2.826C20.674 2.928 21 3.333 21 3.802V13.789C21 15.795 19.997 17.669 18.328 18.781L12 23L5.672 18.781C4.002 17.668 3 15.795 3 13.79V3.802C3 3.333 3.326 2.928 3.783 2.826L12 1ZM12 3.049L5 4.604V13.789C5 15.126 5.668 16.375 6.781 17.117L12 20.597L17.219 17.117C18.332 16.375 19 15.127 19 13.79V4.604L12 3.049Z",
    fill: "#2262ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "terms-icon",
    d: "M16.7065 9.21817L15.3032 7.8164L11.1429 11.9758L9.16724 9.99942L7.67969 11.487L11.0586 14.866L16.7065 9.21817Z",
    fill: "#2262ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroShieldIcon);
export default __webpack_public_path__ + "static/media/intro_shield_icon.00de3e6be3e71981f9358194b48a007d.svg";
export { ForwardRef as ReactComponent };